var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tenant-representative" },
    [
      _c("p", { staticClass: "top-title" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("tenancy.tenantRepresentative")) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.editable
        ? _c(
            "div",
            { staticClass: "editabel input-areas" },
            [
              _vm._l(_vm.accountsOfTenancy, function (item, index) {
                return _c(
                  "div",
                  { key: "tenancy_" + item.id, staticClass: "content" },
                  [
                    _c(
                      "div",
                      { staticClass: "name" },
                      _vm._l(_vm.getFullnameSorts, function (fullnameObj) {
                        return _c("InputField", {
                          key: fullnameObj.key,
                          attrs: {
                            label:
                              !index && fullnameObj.isFirst
                                ? _vm.$t("user.tenantName")
                                : "",
                            placeholder: _vm.$t(
                              "contact.basic." + fullnameObj.label
                            ),
                            readonlyAsInput: true,
                            showColon: false,
                            value:
                              item.TenancyAccount["contact" + fullnameObj.key],
                          },
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("InputField", {
                      staticClass: "email",
                      attrs: {
                        label: !index ? _vm.$t("user.email") : "",
                        readonlyAsInput: true,
                        placeholder: "",
                        showColon: false,
                        value: item.username,
                        inputTip: _vm.$t("hint.inputTip.email"),
                      },
                    }),
                    _vm._v(" "),
                    _c("InputField", {
                      staticClass: "phone-tenancy",
                      attrs: {
                        readonlyAsInput: true,
                        label: !index
                          ? _vm.$t("contact.phone.primaryPhone")
                          : "",
                        placeholder: "",
                        showColon: false,
                        value: item.TenancyAccount.phone,
                      },
                    }),
                    _vm._v(" "),
                    _c("InputField", {
                      staticClass: "alt-phone-tenancy",
                      attrs: {
                        readonlyAsInput: true,
                        label: !index ? _vm.$t("user.altPhone") : "",
                        placeholder: "",
                        showColon: false,
                        showFlag: false,
                        value: item.TenancyAccount.altPhone,
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.accounts, function (item, index) {
                return _c(
                  "div",
                  { key: "rep_" + item.id, staticClass: "content" },
                  [
                    _c(
                      "div",
                      { staticClass: "name" },
                      _vm._l(_vm.getFullnameSorts, function (fullnameObj) {
                        return _c("InputField", {
                          key: "TR_" + fullnameObj.key,
                          attrs: {
                            label:
                              !(_vm.accountsOfTenancy.length + index) &&
                              fullnameObj.isFirst
                                ? _vm.$t("user.tenantName")
                                : "",
                            placeholder: _vm.$t(
                              "contact.basic." + fullnameObj.label
                            ),
                            readonly: !_vm.editable || _vm.isReadOnly(item),
                            readonlyAsInput: _vm.isReadOnly(item),
                            showColon: false,
                            value:
                              item.TenantProjectAccount[
                                "contact" + fullnameObj.key
                              ],
                            required: "",
                          },
                          on: {
                            updateValue: function (val) {
                              return _vm.updateContactAttr(
                                "contact" + fullnameObj.key,
                                val,
                                index
                              )
                            },
                          },
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("InputField", {
                      class: [
                        "email",
                        { error: _vm.duplicateEmailIndexMap[index] },
                      ],
                      attrs: {
                        readonly: !_vm.editable || _vm.isReadOnly(item),
                        readonlyAsInput:
                          _vm.isReadOnly(item) || _vm.isCurrentUser(item),
                        label: !(_vm.accountsOfTenancy.length + index)
                          ? _vm.$t("user.email")
                          : "",
                        placeholder: "",
                        showColon: false,
                        value: item.username,
                        inputTip: _vm.$t("hint.inputTip.email"),
                        pattern: _vm.regex.email,
                        required: "",
                      },
                      on: {
                        updateValue: function (val) {
                          return _vm.updateContactUsername(val, index)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("InputField", {
                      class: [
                        "phone",
                        { error: _vm.duplicatePhoneIndexMap[index] },
                      ],
                      attrs: {
                        readonly: !_vm.editable || _vm.isReadOnly(item),
                        readonlyAsInput: _vm.isReadOnly(item),
                        label: !(_vm.accountsOfTenancy.length + index)
                          ? _vm.$t("contact.phone.primaryPhone")
                          : "",
                        placeholder: "",
                        showColon: false,
                        value: item.TenantProjectAccount.phone,
                        required: "",
                      },
                      on: {
                        updateValue: function (val) {
                          return _vm.updateContactAttr("phone", val, index)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("InputField", {
                      class: [
                        "alt-phone",
                        { error: _vm.duplicatePhoneIndexMap[index] },
                      ],
                      attrs: {
                        readonly: !_vm.editable || _vm.isReadOnly(item),
                        readonlyAsInput: _vm.isReadOnly(item),
                        label: !(_vm.accountsOfTenancy.length + index)
                          ? _vm.$t("user.altPhone")
                          : "",
                        placeholder: "",
                        showColon: false,
                        showFlag: false,
                        value: item.TenantProjectAccount.altPhone,
                      },
                      on: {
                        updateValue: function (val) {
                          return _vm.updateContactAttr("altPhone", val, index)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.allowRemove(item)
                      ? _c("i", {
                          staticClass: "fa fa-times",
                          on: {
                            click: function ($event) {
                              return _vm.deleteAccount(index)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.showAddBtn
                ? _c(
                    "span",
                    {
                      staticClass: "addAccount",
                      on: { click: _vm.addAccount },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.addContact")) + "+")]
                  )
                : _vm._e(),
            ],
            2
          )
        : _c(
            "ul",
            { class: ["display-table", { creator: _vm.showInviteBtn }] },
            [
              _c("div", { staticClass: "table-header" }, [
                _c("span", { staticClass: "serial" }),
                _vm._v(" "),
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.$t("user.tenantName"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "email" }, [
                  _vm._v(_vm._s(_vm.$t("user.email"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "phone" }, [
                  _vm._v(_vm._s(_vm.$t("contact.phone.primaryPhone"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "other-phone" }, [
                  _vm._v(_vm._s(_vm.$t("user.altPhone"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "lastlogin" }, [
                  _vm._v(_vm._s(_vm.$t("lastLogin"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "invited-at" }, [
                  _vm._v(_vm._s(_vm.$t("invitedAt"))),
                ]),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showInviteBtn,
                      expression: "showInviteBtn",
                    },
                  ],
                  staticClass: "invite",
                }),
              ]),
              _vm._v(" "),
              _vm._l(_vm.accountsOfTenancy, function (item, index) {
                return _c(
                  "li",
                  { key: item.id + "_" + index, staticClass: "table-content" },
                  [
                    _c("span", { staticClass: "serial" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "name" }, [
                      _vm._v(
                        _vm._s(
                          _vm.displayI18nFullName(
                            item.TenancyAccount.contactFirstName,
                            item.TenancyAccount.contactLastName
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "email" }, [
                      _vm._v(_vm._s(item.username)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "phone" }, [
                      _vm._v(
                        _vm._s(
                          item.TenancyAccount.phone || _vm.$t("emptyValue")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "other-phone" }, [
                      _vm._v(
                        _vm._s(
                          item.TenancyAccount.altPhone || _vm.$t("emptyValue")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "lastlogin" }, [
                      _vm._v(_vm._s(_vm.formatDate(item.lastLoginAt))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "invited-at" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatDate(item.TenancyAccount.invitedAt) || "-"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showInviteBtn,
                          expression: "showInviteBtn",
                        },
                      ],
                      staticClass: "invite",
                      style: {
                        visibility: _vm.isCurrentUser(item)
                          ? "hidden"
                          : "visible",
                      },
                    }),
                  ]
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.filterAccounts, function (item, index) {
                return _c("li", { key: index, staticClass: "table-content" }, [
                  _c("span", { staticClass: "serial" }, [
                    _vm._v(_vm._s(_vm.getOrdinalFor(index + 1))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "name" }, [
                    _vm._v(
                      _vm._s(
                        _vm.displayFullName(
                          item.TenantProjectAccount.contactFirstName,
                          item.TenantProjectAccount.contactLastName
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "email" }, [
                    _vm._v(_vm._s(item.username || "--")),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "phone" }, [
                    _vm._v(_vm._s(item.TenantProjectAccount.phone || "--")),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "other-phone" }, [
                    _vm._v(_vm._s(item.TenantProjectAccount.altPhone || "--")),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "lastlogin" }, [
                    _vm._v(_vm._s(_vm.formatDate(item.lastLoginAt))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "invited-at" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatDate(item.TenantProjectAccount.invitedAt)
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showInviteBtn,
                          expression: "showInviteBtn",
                        },
                      ],
                      staticClass: "invite",
                      style: {
                        visibility: _vm.isCurrentUser(item)
                          ? "hidden"
                          : "visible",
                      },
                    },
                    [
                      !_vm.isReadOnly(item)
                        ? _c(
                            "div",
                            {
                              staticClass: "invite-btn btn btn--orange",
                              on: {
                                click: function ($event) {
                                  return _vm.prepareInvite(item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("action.invite")))]
                          )
                        : _vm._e(),
                    ]
                  ),
                ])
              }),
            ],
            2
          ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "confirm-duplicate-representative",
          attrs: {
            showCloseBtn: false,
            modalId: "duplicate-representative-" + +new Date(),
          },
        },
        [
          _c("div", { staticClass: "font-bold" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("tenantProjects.hintDuplicateRepresentative", [
                    _vm.prepareInvitePerson.username,
                  ])
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                on: { click: _vm.closeModal },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.no")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn btn--orange", on: { click: _vm.doInvite } },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.yes")) + "\n      ")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }